import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimIncludeWorkOrderSeasonGql } from '../../bimWorkOrderQueries';

const requestId = 'bimIncludeWorkOrderSeason';

export const useBimIncludeWorkOrderSeason = (workOrderId?: number) => {
    const dispatch = useDispatch();

    const [bimIncludeWorkOrderSeasonReset] = useResetStoreData({ requestId });

    const onSuccess = useCallback(() => {
        bimIncludeWorkOrderSeasonReset(undefined);
    }, [bimIncludeWorkOrderSeasonReset]);

    const [
        bimIncludeWorkOrderSeasonData,
        bimIncludeWorkOrderSeasonStatus,
        bimIncludeWorkOrderSeasonError,
        bimIncludeWorkOrderSeasonRequest,
    ] = useRequest({
        requestId,
        query: bimIncludeWorkOrderSeasonGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const bimIncludeWorkOrderSeasonMakeRequest = useCallback(
        (contractSeasonId: number) => {
            dispatch(bimIncludeWorkOrderSeasonRequest({ contractSeasonId, workOrderId }));
        },
        [bimIncludeWorkOrderSeasonRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        onSuccess();
    }, [onSuccess]);

    return {
        bimIncludeWorkOrderSeasonData,
        bimIncludeWorkOrderSeasonStatus,
        bimIncludeWorkOrderSeasonError,
        bimIncludeWorkOrderSeasonMakeRequest,
    };
};
